var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.594,
    height: 14.492,
    viewBox: "0 0 11.594 14.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_1_",
    "data-name": "user (1)",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11246",
    "data-name": "Path 11246",
    d: "M4,5.623A3.623,3.623,0,1,1,7.623,9.246,3.623,3.623,0,0,1,4,5.623Z",
    transform: "translate(-0.826 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11249",
    "data-name": "Path 11249",
    d: "M2.061,15.061A3.623,3.623,0,0,1,4.623,14H8.971a3.623,3.623,0,0,1,3.623,3.623v1.449a.725.725,0,0,1-.725.725H1.725A.725.725,0,0,1,1,19.072V17.623A3.623,3.623,0,0,1,2.061,15.061Z",
    transform: "translate(0 -3.305)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.813abc7c1b057f129c78e58e808f4288.svg";
export { ForwardRef as ReactComponent };